"use client";

import { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled"; // GLOBAL CUSTOM COMPONENTS

import { H2, H3, Span } from "../../salify-next-layout/default/components/Typography";
import { FlexBox, FlexRowCenter } from "../../salify-next-layout/default/components/flex-box"; // LOCAL CUSTOM COMPONENT

import FrequentlyProductCard from "./frequently-product-card"; // CUSTOM UTILS LIBRARY FUNCTION

import { Product } from "src/lib/fetcher/client";
import { formatMoney } from "src/lib/utils/formatter";
import SalifyFallback from "../../salify-fallback/default";

// STYLED COMPONENTS
const WrapperBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    "& .card-holder": {
      flexDirection: "column",
    },
  },
})); // ============================================================

// ============================================================
const FrequentlyBought = ({ products }: { products: Product[] }) => {
  const [totals, setTotals] = useState({ salePrice: 0, discountPrice: 0 });
  useEffect(
    () =>
      setTotals(
        products
          .map(({ salePrice }) => ({ salePrice, discountPrice: 0 }))
          .reduce(
            (prev, next) => {
              const discount = 0;
              return {
                salePrice: prev.salePrice + next.salePrice,
                discountPrice: prev.discountPrice + (next.salePrice - next.salePrice * discount),
              };
            },
            { salePrice: 0, discountPrice: 0 },
          ),
      ),
    [products],
  );

  return products.length ? (
    <WrapperBox mb={7.5}>
      <H3 mb={3}>
        <SalifyFallback.Label path="Frequently Bought Together" default="Thường được mua chung" />
      </H3>

      <FlexBox className="card-holder" flexWrap="wrap" m={-1}>
        {products.map((item, ind) => (
          <Fragment key={item.id}>
            <FrequentlyProductCard {...products[ind]} />

            {ind < products.length - 1 && (
              <FlexRowCenter>
                <H2 color="grey.600" mx={1}>
                  +
                </H2>
              </FlexRowCenter>
            )}
          </Fragment>
        ))}

        <FlexRowCenter>
          <H2 color="grey.600" mx={3}>
            =
          </H2>
        </FlexRowCenter>

        <FlexRowCenter
          m={1}
          minWidth={300}
          minHeight={200}
          border="1px solid"
          borderRadius="8px"
          className="gray-box"
          borderColor="grey.400"
          flexDirection="column"
        >
          <H3 color="primary.main">{formatMoney(totals.salePrice)}</H3>

          {totals.discountPrice < totals.salePrice && (
            <Span mb={2} fontWeight="600" color="grey.600">
              `Tiết kiệm ${formatMoney(totals.salePrice - totals.discountPrice)}`
            </Span>
          )}

          <Box px={2}>
            <FlexBox gap={1.5}>
              <Button variant="contained" color="primary">
                <SalifyFallback.Label path="Add To Cart" default="Thêm vào Giỏ hàng" />
              </Button>

              <Button variant="outlined" color="primary">
                <SalifyFallback.Label path="Add To List" default="Thêm vào Danh sách" />
              </Button>
            </FlexBox>
          </Box>
        </FlexRowCenter>
      </FlexBox>
    </WrapperBox>
  ) : null;
};

export default FrequentlyBought;
